import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import { strings } from "../../services/Localization";
import PageContent from "../PageContent";
import {
    faBoltAuto, faRefresh
 }  from '@fortawesome/pro-regular-svg-icons';
 import ProgressBar from 'react-bootstrap/ProgressBar';
import { ActionType, BulkActionType, ColumnType, OptionType } from '../../components/Common/DataTable/DataTypes';
import { DEFAULT_INPUT_VALIDATION, DEFAULT_RECORD_LIMIT, ID_INPUT_VALIDATION } from "../../components/Common/DataTable/DataTableConsts";
import { BreadCrumbType, PageButtonType } from '../../datatypes/datatypes';
import { IUser } from "../../dassTypes";
// import ProgressBar from 'react-bootstrap/ProgressBar';
import { getAppBase, autoRefreshInterval } from "../../utils/consts";
import { SessionStatus } from "./FuotaTypes";
import { generateDevEUIcolumn } from "../../components/Common/columnDefination";


interface IMyCampaignsStates {
    loggedUser: IUser | null;
    editCampaignId: string;
    addCampaign: boolean;
    showAlertModal: boolean;
    pageTitle: string;
    breadCrumbArr: BreadCrumbType[];
    campaignid: string;
    selectedAction: string;
    showLoadingDialog: boolean;
    showConfirmDialog: boolean;
    confirmDialogeSettings: {
        title: string;
        description: string;
        actionLabel: string;
        confirmAction: () => void;
    },
    refresh: boolean;
    exportInit: number;
    autoRefresh:boolean;
};

export interface ActivityLogs {
    unicast_activityLogs: string[]; 
    fragment_activityLogs: string[];
    redundancy_activityLogs: string[];
    reboot_activityLogs: string[];
}

export interface CurrentPhase {
    phase_name: string;
    progress: number;
    in_progress: boolean;
}

export interface DeviceProgress {
    device_id: string;
    deveui: string;

    // per-phase progress (0..100)
    progress_unicast_phase: number;
    progress_fragment_phase: number;
    progress_redun_fragment_phase: number;
    progress_reboot_phase: number;

    activity_logs: ActivityLogs;
    current_phase?: CurrentPhase;
}

export interface ActivityProps {
    item: DeviceProgress;
    unicast: boolean;
}

interface SessionDeviceRow {
    deveui: string;
    activityLog?: string | string[];
    fragIdx?: number;
}

const SessionDevices: React.FC<{}> = () => {
    const { state } = useLocation();

    const navigate = useNavigate();
    let { campaignid, tabname } = useParams();
    // Redirect if no state or no row
    useEffect(() => {
        console.log("useEffect called", state);
        if (!state || !state?.row) {
            console.log("state", state, campaignid, getAppBase());
            if(getAppBase()) {
                navigate(`${getAppBase()}/my-campaigns${campaignid ? `/${campaignid}` : ''}`, { state: {}, replace: true });
            }
        }
    }, [state, campaignid, navigate]);

    const { row } = state || {};


    const stateInit = {
        loggedUser: null,
        editCampaignId: "",
        addCampaign: false,
        pageTitle: strings.MY_APPLICATIONS_TITLE,     // should be translated
        showAlertModal: false,
        breadCrumbArr: [
            {label: strings.NAV_DEVICES_ITEM, url:`${getAppBase()}/my-devices`},
        {label: strings.NAV_FUOTA_CAMPAIGNS_ITEM, url:`${getAppBase()}/my-campaigns`},
        { label: "Sessions", url: `-1`, comment : state?.campaignName  || campaignid || "" },
        { label: "Session Devices", url: '', comment: state?.fuotaGroupName ?? "" }
    ],
        campaignid,
        selectedAction: '',
        showLoadingDialog: false,
        showConfirmDialog: false,
        confirmDialogeSettings: {
            title: '',
            description: '',
            actionLabel: '',
            confirmAction: () => { }
        },
        refresh: false,
        exportInit: 0,
        autoRefresh:false,
    };

    const [deviceState, setDeviceState] = useState<IMyCampaignsStates>(stateInit)

    // Cache latest SessionDeviceRow per device (does NOT trigger re-renders)
    const rowCacheRef = React.useRef<Map<string, SessionDeviceRow>>(new Map());

    const getActions = useCallback(() => {
        let actions: ActionType[] = [];
        let bulkActions: BulkActionType[] = [];

        return { actions, bulkActions };
    }, []);

    const refreshTable = () => {
        setDeviceState(prevState => {
            return {...prevState, refresh:!prevState.refresh}
        })

    }

    const getPageButtons = useCallback(() => {

        const pageButtons: PageButtonType[] = [
            {
				title: "row_height",
				type: 'row_height',
			},
			{
				title: "separator",
				type: "separator"
			},
            {
                title: strings.REFRESH_LIST,
                action: () => { refreshTable() },
                type: 'button',
                icon: faRefresh
            },
            {
                title: (deviceState.autoRefresh) ?  strings.STOP_AUTO_REFRESH : strings.AUTO_REFRESH,
                action: () => {  toggleAutoRefresh() },
                type: 'button_with_icon',
                varient: 'primary',
                icon: faBoltAuto
                
            },
        ]

        return pageButtons;
    }, [deviceState.autoRefresh]);

    const toggleAutoRefresh = () => {
        setDeviceState(prev => ({ ...prev, autoRefresh: !prev.autoRefresh }));
    };

    const clampPct = (n: number) => Math.max(0, Math.min(100, n));

    const normalizeLogs = (raw?: string | string[]): string[] =>
        Array.isArray(raw) ? raw : raw ? String(raw).split(",").map(s => s.trim()).filter(Boolean) : [];

    const expectedAcksFor = (isUnicastFragmentMode: boolean) => (isUnicastFragmentMode ? 2 : 5);

    const sendActivityLogsPhasewise = (activityLogs: string[]): ActivityLogs => {
        activityLogs = activityLogs.includes('.') ? activityLogs.filter(i => i !== '.') : activityLogs;

        let unicast_activityLogs: string[] = [...activityLogs];
        let fragment_activityLogs: string[] = [...activityLogs];
        let redundancy_activityLogs: string[] = [...activityLogs];
        let reboot_activityLogs: string[] = [...activityLogs];

        let unicast_activity_index: number = unicast_activityLogs.indexOf('Setup Complete');
        if (unicast_activity_index < 0) {
            unicast_activity_index = unicast_activityLogs.findIndex(i => i.includes('Setup Failed'));
            unicast_activityLogs = unicast_activity_index > 0 ? unicast_activityLogs.slice(0, unicast_activityLogs.length) : unicast_activityLogs;
            unicast_activity_index = unicast_activityLogs.length - 1;
        } else {
            unicast_activityLogs = unicast_activity_index >= 0 ? unicast_activityLogs.slice(0, unicast_activity_index + 1) : unicast_activityLogs;
        }

        // convert fragment activity log string from array
        let fragment_activity_last_index: number = fragment_activityLogs.findIndex(i => i.includes('Sending Redundancy Fragments:'));
        if (fragment_activity_last_index < 0) {
            fragment_activity_last_index = fragment_activityLogs.findIndex(i => i.includes('Multicast error'))
        }
        if (fragment_activity_last_index < 0) {
            fragment_activity_last_index = fragment_activityLogs.findIndex(i => i.includes('Sending Fragments'))
            fragment_activity_last_index = fragment_activity_last_index > 0 ? fragment_activity_last_index + 1 : fragment_activity_last_index;
        }
        fragment_activityLogs = fragment_activity_last_index > 0 ? fragment_activityLogs.slice(unicast_activity_index + 1, fragment_activity_last_index) : fragment_activityLogs.slice(unicast_activity_index + 1, fragment_activityLogs.length);

        // convert redundancy activity log string from array
        let redundancy_activity_last_index: number = redundancy_activityLogs.indexOf('rebootMsgReq');
        redundancy_activityLogs = redundancy_activity_last_index > 0 ? redundancy_activityLogs.slice(fragment_activity_last_index, redundancy_activity_last_index) : fragment_activity_last_index > 0 ? redundancy_activityLogs.slice(fragment_activity_last_index, redundancy_activityLogs.length) : [];

        //convert reboot activity log string from array
        reboot_activityLogs = redundancy_activity_last_index > 0 ? reboot_activityLogs.slice(redundancy_activity_last_index, reboot_activityLogs.length) : [];

        const prettify = (arr: string[]): string[] => {
            if (!arr || arr.length === 0) return [];

            const clean = (s: string) => s.trim().replace(/ +/g, " ");

            const sendingRe = /^sending(?:\s+redundancy)?\s+fragments\b/i;
            const standalone = new Set([
                "Device rebooted",
                "Restarting unicast setup (device reset)",
                "Unexpected device reset",
                "Multicast session timeout exceeded",
            ]);

            // Helper function to determine if a log entry is standalone
            const isStandalone = (s: string) => standalone.has(s) || sendingRe.test(s);

            const out: string[] = [];
            for (let i = 0; i < arr.length; ) {
                const a = clean(arr[i]);

                if (isStandalone(a)) {
                    out.push(a);
                    i += 1;

                    // skip pairing logic
                    continue;
                }

                const hasNext = i + 1 < arr.length;
                const b = hasNext ? clean(arr[i + 1]) : "";

                if (!hasNext || isStandalone(b) || b === "") {
                    out.push(a);
                    if (hasNext && isStandalone(b)) out.push(b);
                    i += hasNext && isStandalone(b) ? 2 : 1;
                } else {
                    out.push(`${a} → ${b}`);
                    i += 2;
                }
            }

            return out;
        };

        const phaseLogs: ActivityLogs = {
            unicast_activityLogs: prettify(unicast_activityLogs),
            fragment_activityLogs: prettify(fragment_activityLogs),
            redundancy_activityLogs: prettify(redundancy_activityLogs),
            reboot_activityLogs: prettify(reboot_activityLogs),
        }

        return phaseLogs;
    }

    const getCurrentPhaseFromDeviceSessionProgress = (progress: DeviceProgress, unicast: boolean): CurrentPhase => {
        const sendingFragmentsLabel = unicast
            ? "Unicast Fragments Phase"
            : "Multicast Fragments Phase";

        const sendingRedunFragmentsLabel = unicast
            ? "Unicast Redundancy Fragments Phase"
            : "Multicast Redundancy Fragments Phase";

        let current_phase: CurrentPhase = {
            phase_name: "Unicast Setup Phase",
            progress: progress.progress_unicast_phase,
            in_progress: true,
        };

        if (progress.progress_unicast_phase === 100) {
            current_phase = {
                phase_name: sendingFragmentsLabel,
                progress: progress.progress_fragment_phase,
                in_progress: true,
            };
        }
        if (progress.progress_fragment_phase === 100) {
            current_phase = {
                phase_name: sendingRedunFragmentsLabel,
                progress: progress.progress_redun_fragment_phase,
                in_progress: true,
            };
        }
        if (progress.progress_redun_fragment_phase === 100) {
            current_phase = {
                phase_name: "Device Reboot Phase",
                progress: progress.progress_reboot_phase,
                in_progress: true,
            };
        }

        return current_phase;
    };

    const deriveDeviceProgress = (session: any, deviceData: SessionDeviceRow): DeviceProgress | null => {
        const { deveui} = deviceData;
        if (!session?.devices?.includes(deveui)) return null;

        const groupType = session?.fuotaGroup?.groupType ?? "";
        const isUnicastFragmentMode = groupType === "A";
        const expectedCmdAckCount = expectedAcksFor(isUnicastFragmentMode);

        // Prefer the session report entry for this row's device when available
        const deviceEntry = session?.report
            ? (session.report as SessionDeviceRow[]).find((i) => i?.deveui === deveui) ?? null
            : deviceData;
                    
        const activityLogs = normalizeLogs(deviceEntry?.activityLog);

        const hasFragCfg = !!session?.fragmentConfig;
        const nbFrag = hasFragCfg ? Number(session.fragmentConfig.nbFrag ?? 1) : 1;
        const nbRedunFrag = hasFragCfg ? Number(session.fragmentConfig.nbRedunFrag ?? 1) : 1;

        // API now returns fragIdx for every device in multicast sessions too
        const fragIdx = deviceEntry?.fragIdx != null ? Number(deviceEntry.fragIdx) : null;

        let progress_fragment_phase =
            fragIdx != null ? clampPct((Math.min(nbFrag, fragIdx) / Math.max(1, nbFrag)) * 100) : 0;

        let progress_redun_fragment_phase = activityLogs.some(s => s.includes("fragDataBlockReceivedReq"))
            ? 100
            : (fragIdx != null && fragIdx > nbFrag
                ? clampPct(((fragIdx - nbFrag) / Math.max(1, nbRedunFrag)) * 100)
                : 0);

        let cmdAckCount = 0;
        if (!isUnicastFragmentMode) {
            const cmds = ["mcPktMsgAck", "fmPktMsgAck", "mcSetupMsgAck", "mcTimedSessMsgAck", "fmSetupMsgAck"];
            cmdAckCount = cmds.reduce((a, c) => a + (activityLogs.includes(c) ? 1 : 0), 0);
        } else {
            if (activityLogs.some(s => s.includes("fmPktMsgAck")))   cmdAckCount++;
            if (activityLogs.some(s => s.includes("fmSetupMsgAck"))) cmdAckCount++;
        }

        const rebootSignals = ["rebootMsgReq", "Device rebooted"];
        let rebootAckCount = rebootSignals.reduce(
            (a, c) => a + (activityLogs.some(i => i.toLowerCase().includes(c.toLowerCase())) ? 1 : 0), 0
        );

        if (activityLogs.some(i => /finished/i.test(i))) rebootAckCount++;

        let progress_unicast_phase = Number((cmdAckCount / expectedCmdAckCount) * 100);
        let progress_reboot_phase = Number((rebootAckCount / 3) * 100);

        // Make phases monotonic
        if (progress_fragment_phase > 0) progress_unicast_phase = 100;
        if (progress_redun_fragment_phase > 0) {
            progress_unicast_phase = 100;
            progress_fragment_phase = 100;
        }
        if (progress_reboot_phase > 0) {
            progress_unicast_phase = 100;
            progress_fragment_phase = 100;
            progress_redun_fragment_phase = 100;
        }

        const activity_logs = sendActivityLogsPhasewise(activityLogs);

        const deviceProgress: DeviceProgress = {
            device_id: deveui,
            deveui,
            progress_fragment_phase,
            progress_redun_fragment_phase,
            progress_unicast_phase,
            progress_reboot_phase,
            activity_logs,
        };

        // current_phase
        deviceProgress.current_phase = session.status === SessionStatus.InProgress
            ? getCurrentPhaseFromDeviceSessionProgress(deviceProgress, isUnicastFragmentMode)
            : { phase_name: session.status, progress: 0, in_progress: false };

        return deviceProgress;
    };

    const averageDeviceProgress = (dp: DeviceProgress): number => {
        const sum = dp.progress_unicast_phase + dp.progress_fragment_phase + dp.progress_redun_fragment_phase + dp.progress_reboot_phase;
        return Number((sum / 4).toFixed(2));
    };

    const renderProgressActivity = (rowData: SessionDeviceRow): React.ReactNode => {
        
        // Store the most recent row for this device
        rowCacheRef.current.set(rowData.deveui, rowData);
        
        const session = row;
        const deviceProgress = deriveDeviceProgress(session, rowData);
        if (!deviceProgress) return null;

        // FIXME: Avoid mutating session in render function. Minimal, safe mutations for this device only, with de-duplication.
        session.progress = session.progress ?? { devices: [], total: 0 };
        session.progress.devices = Array.isArray(session.progress.devices) ? session.progress.devices : [];

        const idx = session.progress.devices.findIndex((d: any) => d?.deveui === deviceProgress.deveui);
        if (idx >= 0) session.progress.devices[idx] = deviceProgress;
        else session.progress.devices.push(deviceProgress);

        const isUnicastFragmentMode = (session?.fuotaGroup?.groupType ?? "") === "A";
        return <Activity item={deviceProgress} unicast={isUnicastFragmentMode} />;
    };

    const buildActivityCopyValue = (rowData: SessionDeviceRow): string => {
        const session = row; 
        const unicastType = session?.fuotaGroup?.["groupType"];
        const isUnicast = unicastType === "A";

        const setupLabel = "Unicast Setup Phase";
        const fragmentsLabel = isUnicast ? "Unicast Fragments Phase" : "Multicast Fragments Phase";
        const redundancyLabel = isUnicast ? "Unicast Redundancy Fragments Phase" : "Multicast Redundancy Fragments Phase";
        const rebootLabel = "Device Reboot Phase";

        let activityLogs = normalizeLogs(rowData.activityLog);

        // prefer report logs if present
        const report = session?.report;
        if (report) {
            const dev = report.find((i: any) => i.deveui === rowData.deveui);
            if (dev) activityLogs = normalizeLogs(dev.activityLog);
        }

        const logs = sendActivityLogsPhasewise(activityLogs);

        const sections: string[] = [];
        if (logs.unicast_activityLogs.length) {
            sections.push(`${setupLabel}:\n${logs.unicast_activityLogs.join("\n")}`);
        }
        if (logs.fragment_activityLogs.length) {
            sections.push(`${fragmentsLabel}:\n${logs.fragment_activityLogs.join("\n")}`);
        }
        if (logs.redundancy_activityLogs.length) {
            sections.push(`${redundancyLabel}:\n${logs.redundancy_activityLogs.join("\n")}`);
        }
        if (logs.reboot_activityLogs.length) {
            sections.push(`${rebootLabel}:\n${logs.reboot_activityLogs.join("\n")}`);
        }

        return sections.join("\n\n");
    };

    // Clear cache whenever user manually/auto refresh so it repopulates cleanly
    useEffect(() => {
        rowCacheRef.current.clear();
    }, [deviceState.refresh]);

    // Auto-refresh interval
    useEffect(() => {
        const interval = setInterval(() => {
            if(deviceState.autoRefresh) {
                refreshTable();
            }
        }, autoRefreshInterval);
        return () => clearInterval(interval);
    }, [deviceState.autoRefresh]);

    // Recompute session progress summary
    useEffect(() => {
        const session = row;
        if (!session) return;

        let deviceRows: SessionDeviceRow[] = [];

        // Prioritize FUOTA session report (i.e., session complete) over cached rows (session in-progress)
        if (Array.isArray(session.report) && session.report.length > 0) {
            deviceRows = session.report as SessionDeviceRow[];
        } else {
            deviceRows = Array.from(rowCacheRef.current.values());
        }

        if (deviceRows.length === 0) return;

        const progressList = deviceRows
            .map(deviceData => deriveDeviceProgress(session, deviceData))
            .filter((v): v is DeviceProgress => !!v);

        session.progress = session.progress ?? { devices: [], total: 0 };
        session.progress.devices = progressList;

        const totals = progressList.map(averageDeviceProgress);
        session.progress.total = totals.length
            ? Number((totals.reduce((a, b) => a + b, 0) / totals.length).toFixed(2))
            : 0;
    }, [
        Array.isArray(row?.report) ? row.report.length : 0,
        row?.fragmentConfig,
        row?.fuotaGroup?.groupType,
        row?.status,
        deviceState.refresh,  // Manual/auto refresh triggers recompute
    ]);

    const Activity: React.FC<ActivityProps> = ({ item, unicast }) => {
        const hasLogs = (v: unknown): boolean =>
            Array.isArray(v) ? v.length > 0 : typeof v === "string" ? v.trim().length > 0 : false;

        const sendingFragmentsLabel = unicast
            ? "Unicast Fragments Phase"
            : "Multicast Fragments Phase";

        const sendingRedundancyFragmentsLabel = unicast
            ? "Unicast Redundancy Fragments Phase"
            : "Multicast Redundancy Fragments Phase";

        const PhaseRow: React.FC<{ title: string; progress: number; logs: string[] }> = ({ title, progress, logs }) => (
            <div className="d-flex align-items-start gap-3 mb-3">
                {/* LEFT: title + progress */}
                <div className="flex-shrink-0" style={{ width: 260 }}>
                    <b className="d-block mb-1">{title}</b>

                    {progress === 100 ? (
                        <span className="fw-semibold">Done</span>
                    ) : progress > 0 ? (
                        // Progress bar with percentage below the bar
                        <div>
                            <div style={{ width: 120 }}>
                                <ProgressBar
                                    striped
                                    animated
                                    now={Number(progress) || 0}
                                    style={{
                                        ['--bs-progress-bar-bg' as any]: '#003366', // dark blue
                                    }}
                                />
                            </div>
                            <div className="mt-1">
                                <span>{Number(progress).toFixed(2)}%</span>
                            </div>
                        </div>
                    ) : (
                        // No bar yet, just show (0.00%)
                        <span>({Number(progress).toFixed(2)}%)</span>
                    )}
                </div>

                {/* RIGHT: logs */}
                <div className="flex-grow-1">
                    <pre className="mb-0">{(logs || []).join("\n")}</pre>
                </div>
            </div>
        );

        return (
            <div className="col d-flex flex-column text-start">
                {hasLogs(item?.activity_logs?.unicast_activityLogs) && (
                    <PhaseRow
                        title="Unicast Setup Phase"
                        progress={Number(item?.progress_unicast_phase) || 0}
                        logs={item?.activity_logs?.unicast_activityLogs || []}
                    />
                )}

                {hasLogs(item?.activity_logs?.fragment_activityLogs) && (
                    <PhaseRow
                        title={sendingFragmentsLabel}
                        progress={Number(item?.progress_fragment_phase) || 0}
                        logs={item?.activity_logs?.fragment_activityLogs || []}
                    />
                )}

                {hasLogs(item?.activity_logs?.redundancy_activityLogs) && (
                    <PhaseRow
                        title={sendingRedundancyFragmentsLabel}
                        progress={Number(item?.progress_redun_fragment_phase) || 0}
                        logs={item?.activity_logs?.redundancy_activityLogs || []}
                    />
                )}

                {hasLogs(item?.activity_logs?.reboot_activityLogs) && (
                    <PhaseRow
                        title="Device Reboot Phase"
                        progress={Number(item?.progress_reboot_phase) || 0}
                        logs={item?.activity_logs?.reboot_activityLogs || []}
                    />
                )}
            </div>
        );
    };

    const initDataTable = () => {

        let actions: any = [];
        let pageButtons: PageButtonType[] = [];

        actions = getActions();
        let columns: ColumnType[] = [
            generateDevEUIcolumn({
                key: "deveui"
            }),
            {
                key: "upgradeStatus",
                type: "text",
                title: "Status",
                render: (row) => (
                    <div className="d-flex align-items-center justify-content-start gap-2 text-start">
                        <span>{row.upgradeStatus || "—"}</span>
                    </div>
                ),
                maxInputLength: 40,
                filterable: false,
                filterField: "search_deveui",
                filterType: "text",
                inputValidation: ID_INPUT_VALIDATION,
                sortable: false,
                sortKey: "sort_by_deveui",
                cellWidth: 20,
                copyLink: false,
                width: 200,
                minWidth: 200,
                resizable: true,
            },
            {
                key: "activityLog",
                title: "Progress & Activity Log",
                type: "text",
                render: (row) => { return renderProgressActivity(row)},
                filterable: false,
                filterField: "search_comment",
                filterType: "text",
                inputValidation: DEFAULT_INPUT_VALIDATION,
                sortable: false,
                sortKey: "sort_by_comment",
                filterParams: {},
                cellWidth: 10,
                width: 400,
                minWidth: 400,
                flex: 2,
                resizable: true,
                enableMultilineCellRender: true,
                showCopyLink: true, 
                copyValue: (row) => buildActivityCopyValue(row),
            }
        ];
        let options: OptionType = {
            url: `/uiapi/rest/fuota/sessions/${state?.sessionId}/devices`,
            query_param: {all: true, get_pages: true, limit: DEFAULT_RECORD_LIMIT, stream:'progress' },
            serial_number: false,
            id_field: 'deveui',
            oboe_path: 'pages.*',
            available_key: 'deveui',
            defaultSortField: 'sort_by_deveui',
            defaultSortOrder: 'asc',
            allowBulkActions: false,
            emptyDataMsg: '<b>Sorry!</b> No Devices Available',
            agGridAdjustWidthKeys: ['upgradeStatus', 'activityLog']
        }

        return { ...actions, columns, ...options, pageButtons };
    }

    let refresh = deviceState.refresh;

    return (
        <>
        <PageContent
            name="Devices"
            id={undefined}
            tabname={tabname}
            actions={getActions()}
            breadCrumbArr={deviceState.breadCrumbArr}
            pageButtons={getPageButtons()}
            countLabel={`Session Devices`}
            dataTableOption={initDataTable()}
            exportInit={deviceState.exportInit}
            refresh={refresh}
            ></PageContent>
        </>
    )
}

export default SessionDevices;
